import { render, staticRenderFns } from "./CollectionHistory.vue?vue&type=template&id=70c8a890&scoped=true"
import script from "./CollectionHistory.vue?vue&type=script&lang=js"
export * from "./CollectionHistory.vue?vue&type=script&lang=js"
import style0 from "./CollectionHistory.vue?vue&type=style&index=0&id=70c8a890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c8a890",
  null
  
)

export default component.exports